export default __webpack_public_path__ + "static/media/battery-page-image.53ca7dc1.png";